import React from "react";
import Footer from "./components/Footer/Footer.SA";
import ConfigRouter from "./ConfigRouter.SA";
import LoadingIndicator from "./components/Loading/LoadingIndicator";
import Header from "./components/Header/Header.SA";
import loader from './images/ImagesSA/loader.gif'
import HelmetIndex from "./components/Header/HelmetIndex";
 class App extends React.Component {
  render() {
    return (
      <div className="container-fluid">
        <HelmetIndex/>
        <Header/>
        <ConfigRouter/>
        <Footer/>
        <LoadingIndicator>
          {<img alt="Imagen Cargando" src={loader} />}
        </LoadingIndicator>
      </div>
    );
  }
}
export default  App ;
